module.exports = __webpack_public_path__ + "img/Beginner-3.67544ebf.gif";